
define(
    'Facets.Translator.Extension',
    [
        'Facets.Translator',
        'underscore',
        'Utils'
    ],
    function (
        FacetsTranslator,
        _,
        Utils

    ) {
        'use strict';

        _.extend(FacetsTranslator.prototype, {
            parseUrlOptions: function (options) {
                function escapeInvalidPercentSequences(str) {
                    // Replace lone '%' characters with '%25'
                    return str.replace(/%(?![0-9a-fA-F]{2})/g, '%25');
                }

                // Preprocess options.keywords to escape invalid percent sequences
                if (options.keywords) {
                    options.keywords = escapeInvalidPercentSequences(options.keywords);
                }

                this.options.show = options.show || this.configuration.defaultShow;
                this.options.order = options.order || this.configuration.defaultOrder;
                this.options.page = parseInt(options.page, 10) || 1;
                this.options.display = options.display || this.configuration.defaultDisplay;
                this.options.keywords = options.keywords
                    ? decodeURIComponent(options.keywords)
                    : this.configuration.defaultKeywords;
            },
            getOptionValue: function getOptionValue(option_id) {
                function safeDecodeURIComponent(str) {
                    try {
                        return decodeURIComponent(str);
                    } catch (e) {
                        // Escape any invalid percent-encoded sequences
                        return str.replace(/%(?![0-9a-fA-F]{2})/g, '%25');
                    }
                }

                var value = this.options[option_id] || null;

                if (typeof value === 'string') {
                    value = safeDecodeURIComponent(value);
                }

                return value;
            }

        });
    });
